module.exports = __webpack_public_path__ + "media/images/ecobank-bf45197b967f6d7d377c34bdab2bf1dc.png";